import { AuthService } from "@/services/network/auth";
import useAuthStore, { User } from "@/store/authStore";
import { useMutation } from "@tanstack/react-query";
import { jwtDecode } from "jwt-decode";
import { useSnackbar } from "notistack";
interface VerifyCredentials {
  token: string;
}

const authService = new AuthService();

const useAuth = () => {
  const { enqueueSnackbar } = useSnackbar();

  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const _handleVerifySuccess = useAuthStore(
    (state) => state._handleVerifySuccess
  );
  const _handleLogoutSuccess = useAuthStore(
    (state) => state._handleLogoutSuccess
  );
  const _handleSetUserInfo = useAuthStore((state) => state.setUserInfo);

  const mutation = useMutation({
    mutationFn: (credentials: VerifyCredentials) =>
      authService.verify(credentials.token),
    retry: false,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onSuccess: (data: any) => {
      const token = data?.data?.accessToken;
      if (token && typeof token === "string") {
        const user: User = jwtDecode(token);
        _handleVerifySuccess(token, data?.data?.refreshToken);
        _handleSetUserInfo(user);
      } else {
        throw new Error("Verify failed: Invalid server response.");
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onError: (error: Error) => {
      enqueueSnackbar("Verify failed!", {
        variant: "error",
      });
      _handleLogoutSuccess();
    },
  });

  const logout = () => {
    _handleLogoutSuccess();
    // update the url to the login page
    window.location.href = import.meta.env.VITE_REDIRECT_AFTER_LOGOUT;
  };

  return {
    isLoggedIn,
    verify: mutation.mutate,
    statusVerify: mutation.status,
    isPendingVerify: mutation.isPending,
    logout,
  };
};

export default useAuth;
